export const API_BASE_URL = "https://eleveight-prod.azurewebsites.net/api/";
export const OrginUrl = window.location.origin;
